module.exports = __webpack_public_path__ + "fonts/FixitIcons.b21eb98.woff";